import { render, staticRenderFns } from "./joinLottery.vue?vue&type=template&id=6fae4ef4&scoped=true&"
import script from "./joinLottery.vue?vue&type=script&lang=js&"
export * from "./joinLottery.vue?vue&type=script&lang=js&"
import style0 from "./joinLottery.vue?vue&type=style&index=0&id=6fae4ef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fae4ef4",
  null
  
)

export default component.exports